import { useCallback } from 'react';
import { useFreshdeskContextState } from 'store';

const useIsRecordsColumnVisible = () => {
  const { getUiControlsConfigs } = useFreshdeskContextState();

  return useCallback(columnKey => getUiControlsConfigs?.()?.recordsList?.table?.columns?.[columnKey]?.visible === true, [getUiControlsConfigs]);
};

export default useIsRecordsColumnVisible;
